module.exports = __webpack_public_path__ + "img/milestone__1976.615a530c.jpg";